import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    olPaper: {
      marginTop: theme.spacing(4),
      padding: 0,
    },
    root: {
      borderBottom: `1px solid ${theme.gray200}`,
      padding: theme.spacing(12),
    },
    header: {
      color: theme.primary800,
      fontSize: 16,
      fontWeight: "normal",
      lineHeight: theme.spacing(10),
      margin: 0,
      "& > a": {
        color: theme.primary800,
        textDecoration: "underline",
      },
    },
    timelineSection: {
      borderLeft: `1px solid ${theme.gray400}`,
      display: "flex",
      flexDirection: "column",
      marginLeft: theme.spacing(3),
      marginTop: theme.spacing(3),
    },
    timeline: {
      display: "flex",
      paddingLeft: theme.spacing(10),
      position: "relative",
      gap: theme.spacing(4),
      marginBottom: theme.spacing(12),
      "&::before": {
        background: theme.white50,
        border: `2px solid ${theme.primary500}`,
        borderRadius: "50%",
        content: "''",
        height: theme.spacing(7),
        left: "-0.5px",
        position: "absolute",
        top: 7,
        transform: "translate(-50%, -50%)",
        width: theme.spacing(7),
        zIndex: 999,
      },
      "& + &": {
        marginTop: theme.spacing(12),
      },
    },
    lastTimeline: {
      "&::after": {
        background: theme.white50,
        content: "''",
        height: "calc(100% + 16px)",
        left: "-2px",
        position: "absolute",
        top: theme.spacing(7),
        width: theme.spacing(2),
      },
    },
    icon: {
      background: theme.gray400,
      borderRadius: "50%",
      cursor: "pointer",
      fontSize: 24,
      height: theme.spacing(14),
      marginLeft: theme.spacing(5),
      marginRight: theme.spacing(4),
      marginTop: theme.spacing(-3),
      opacity: 0.2,
      padding: theme.spacing(3),
      width: theme.spacing(14),
    },
    textType: {
      color: theme.gray500,
      fontSize: 12,
      lineHeight: theme.spacing(8),
      textTransform: "uppercase",
    },
    textInfo: {
      color: theme.gray400,
      fontSize: 13,
      lineHeight: theme.spacing(8),

      "& + &": {
        marginLeft: theme.spacing(11),
      },
    },
    flexRow: {
      display: "flex",
    },
    wrapper: {
      display: "flex",
      alignItems: "flex-start",
      gap: theme.spacing(5),
    },
    textDate: {
      color: theme.gray500,
      fontSize: 14,
      lineHeight: theme.spacing(8),
      marginBottom: theme.spacing(3),
      marginRight: theme.spacing(4),
      minWidth: theme.spacing(22),
      whiteSpace: "nowrap",
      width: "85px",
    },
    infoWrapper: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      gap: theme.spacing(5),
    },
    iconBox: {
      position: "relative",
      width: theme.spacing(14),
      height: theme.spacing(14),
    },
    iconWrapper: {
      position: "absolute",
      top: "25%",
      left: 0,
      transform: "translateY(-50%)",
      borderRadius: "50%",
      width: theme.spacing(14),
      height: theme.spacing(14),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: theme.gray100,
      "& svg": {
        color: theme.gray500,
        width: theme.spacing(8),
        height: theme.spacing(8),
        stroke: theme.gray500,
      },
    },
    additionalInfo: {
      display: "flex",
    },
    black: {
      color: theme.primary800,
      textDecoration: "none",
    },
    noDataInfo: {
      margin: 0,
      color: theme.gray500,
      fontSize: 13,
      textAlign: "center",
    },
    sectionHeader: {
      margin: theme.spacing(12, 0, 8, 0),
      color: theme.gray800,
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "22px",
      textTransform: "uppercase",
      textWrap: "nowrap",
    },
    sectionHeaderWrapper: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-end",
      "& > button": {
        marginBottom: theme.spacing(4),
      },
    },
  }),
);
